import React from 'react';
import Modal from './Modal';
import ContactForm from './ContactForm';
import styles from './ContactFormModal.module.css';

/**
 * Modal that shows the contact form. On successful send, calls onSuccess (e.g. close modal + show thank you).
 */
const ContactFormModal = ({ isOpen, onClose, onSuccess }) => {
    const handleSuccess = () => {
        onClose?.();
        onSuccess?.();
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Send us a message"
            showCloseButton={true}
            size="md"
            closeOnOverlay={false}
        >
            <div className={styles.body}>
                <ContactForm
                    onSuccess={handleSuccess}
                    defaultSubject="Request / Get in touch"
                    title={null}
                />
            </div>
        </Modal>
    );
};

export default ContactFormModal;
